import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress,
  IconButton,
  InputAdornment,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { endpoint } from '../../resource/Constant';
import axios from 'axios';

const ChangePasswordWithOtp = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: '',
    otp: '',
    new_password: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendMsg, setResendMsg] = useState('');
  const [resendErr, setResendErr] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    try {
      await axios.post(
        `${endpoint}/change-password`,
        {
          email: form.email,
          otp: form.otp,
          new_password: form.new_password,
        }
      );
      setMessage('Password changed successfully!');
      setForm({ email: '', otp: '', new_password: '' });
      navigate('/lessonplanner/signin');
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        'Failed to change password. Please check your details and try again.'
      );
    }
    setLoading(false);
  };

  // Resend OTP handler
    const handleResendOtp = async () => {
    setResendMsg('');
    setResendErr('');
    setResendLoading(true);
    try {
      await axios.post(`${endpoint}/forgotpassword?email=${encodeURIComponent(form.email)}`);
      setResendMsg('OTP resent successfully! Please check your email.');
    } catch (err) {
      setResendErr(
        err?.response?.data?.message ||
        'Failed to resend OTP. Please check your email and try again.'
      );
    }
    setResendLoading(false);
  };
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f4f6f8',
      }}
    >
      <Paper sx={{ width: '100%', maxWidth: 420, p: 4, borderRadius: 3, boxShadow: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, textAlign: 'center', fontWeight: 'bold', color: '#1976d2' }}>
          Change Password (with OTP)
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            fullWidth
            required
            sx={{ mb: 2 }}
          />
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 2 }}>
            <TextField
              label="OTP"
              name="otp"
              type="text"
              value={form.otp}
              onChange={handleChange}
              required
              fullWidth
            />
            <Button
              variant="outlined"
              color="primary"
              onClick={handleResendOtp}
              disabled={resendLoading || !form.email}
              sx={{ whiteSpace: 'nowrap', minWidth: 110 }}
            >
              {resendLoading ? <CircularProgress size={18} /> : 'Resend OTP'}
            </Button>
          </Box>
          {resendMsg && <Alert severity="success" sx={{ mb: 1 }}>{resendMsg}</Alert>}
          {resendErr && <Alert severity="error" sx={{ mb: 1 }}>{resendErr}</Alert>}
          <TextField
            label="New Password"
            name="new_password"
            type={showNewPassword ? 'text' : 'password'}
            value={form.new_password}
            onChange={handleChange}
            fullWidth
            required
            sx={{ mb: 3 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle new password visibility"
                    onClick={() => setShowNewPassword((show) => !show)}
                    edge="end"
                  >
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
            sx={{ py: 1.2, fontWeight: 600 }}
          >
            {loading ? <CircularProgress size={22} sx={{ color: 'white' }} /> : 'Change Password'}
          </Button>
        </form>
        {message && <Alert severity="success" sx={{ mt: 2 }}>{message}</Alert>}
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}

        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Typography variant="body2">
            Don't want to change password?{' '}
            <Link to="/lessonplanner/signin" style={{ color: '#1976d2', textDecoration: 'underline', fontWeight: 500 }}>
              Sign In
            </Link>
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default ChangePasswordWithOtp;